import Loadable from 'react-loadable';
import Loading from './Loading';
import ModuleRegistry from '../module/ModuleRegistry';

export const Registry = {
  MainLayout: {
    Entry: Loadable({
      loader: () => import('../layouts/MainLayout'),
      loading: Loading,
    }),
  },
  Module: {
    ModuleRegistry,
  },
};

export default Registry;
